export default __webpack_public_path__ + "static/media/logo138x75black.43e7bdf2.png";